<template>
  <aside v-if="ativo">
    <!-- <div class="topico-fundo-mobile" v-if="!habilitaSeLiga"></div>
    <div class="topico-fundo-mobile2" v-if="habilitaSeLiga"></div>-->
    <!-- <div class="topico"> -->
    <div class="topico vivoempauta" v-if="verificaVivoEmPauta">
      <img src="@/assets/imgs/VShow_Roxo.png" />
      <VivoEmPauta
        :link="vivoEmPauta.link"
        :new-tab="vivoEmPauta.tab"
        :image="vivoEmPauta.imagem"
        :date-pub="vivoEmPauta.data"
      />
    </div>

    <div class="topico seliga" v-if="habilitaSeLiga">
      <img src="@/assets/imgs/tabela_de_preco.png" style="width: 300px;"/>
      <div>
        <router-link
          to="/tabela-de-preco"
        >
          Clique aqui e confira a Tabela de Preços de Smartphones, Eletrônicos e Essenciais.
        </router-link>
      </div>
    </div>

    <div class="topico">
      <TituloLateral titulo="Mais Recentes" link="#" :temBotao="false" />
      <recente-loading v-if="carregando.recentes" />
      <ul>
        <li v-for="noticia in getRecentes" :key="noticia.id">
          <router-link
            :to="getLinkNoticia(noticia)"
          >
            <img v-if="noticia.imagem" :src="noticia.imagem" />
            <img v-else src="@/assets/imgs/no-image-portal.jpg" />
            {{ noticia.titulo }}
            <div class="thumb-categoria">{{ noticia.categoria.descricao }}</div>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- <div class="topico">
      <TituloLateral titulo="Conteúdos Vivo TV" link="#" :temBotao="false" />
      <VideoLateral tipo="video" link="https://www.youtube-nocookie.com/embed/D4D8Y_ZGKrU" />
    </div> -->

    <!--    <div class="topico">-->
    <!--      <TituloLateral titulo="MAIS LIDAS" link="#"/>-->
    <!--      <ul>-->
    <!--        <li v-for="(noticia, indice) in lidas" :key="noticia.codigo" v-if="indice <= 2">-->
    <!--          <router-link :to="{path:(getCategoria(noticia) + '/' + noticia.slug)}">-->
    <!--            <a :href="noticia.link">{{noticia.titulo}}</a>-->
    <!--          </router-link>-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->
  </aside>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RecenteLoading from '../../Loading/RecenteLoading';
import VideoLateral from '@/components/layout/conteudo/VideoLateral.vue';
import VivoEmPauta from '@/components/layout/conteudo/VivoEmPauta.vue';
import TituloLateral from '@/components/layout/conteudo/TituloLateral.vue';
import mixins from '@/helpers/mixins';

// const CANAL_PARCEIRO = 6;

export default {
  name: 'BarraLateral',
  mixins: [mixins],
  props: {
    ativo: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VideoLateral,
    VivoEmPauta,
    TituloLateral,
    RecenteLoading,
  },
  computed: {
    ...mapGetters({
      carregando: 'barraLateral/carregando',
      getRecentes: 'barraLateral/getRecentes',
      vivoEmPauta: 'midia/vivoEmPauta',
      seLiga: 'baseSeLiga/seLiga',
      uf: 'user/uf',
    }),
    habilitaSeLiga() {
      return !!this.seLiga.length > 0;
    },
    verificaVivoEmPauta() {
      const { vivoEmPauta } = this;
      return vivoEmPauta && vivoEmPauta.id;
    },
    getLinkNoticia() {
      return (noticia) => (noticia.vivo_se_liga === true || noticia.vivo_se_liga === 1)
        ? { name: 'se-liga', params: { noticia: noticia.slug } }
        : { path: `/categoria/${noticia.categoria.slug}/post/${noticia.slug}` };
    },
  },
  methods: {
    ...mapActions({
      recentes: 'barraLateral/recentes',
      getMidiaVivoEmPauta: 'midia/getMidiaVivoEmPauta',
      getSeLiga: 'baseSeLiga/getSeLiga',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.getSeLiga();
      this.getMidiaVivoEmPauta();
      this.recentes();
    });
  },
  watch: {
    uf() {
      this.getMidiaVivoEmPauta();
      this.recentes();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

aside {
  position: relative;
  background: #f6f6f6;
  border-radius: 5px;
  max-width: 350px;
  min-width: 350px;
  height: auto;
  padding: 30px 0;

  & /deep/img {
    user-select: none !important
  }

  & .topico {
    margin-bottom: 50px;
    z-index: 90;
  }

  & .topico-fundo-mobile {
    display: none;
    z-index: 0;
  }

  & ul {
    margin-top: 15px;
    padding: 0px;

    & li {
      padding: 0px;
      border-bottom: 1px solid #f0f0f0;

      &:first-child {
        padding-top: 0px;
      }

      &:last-child {
        border-bottom: 0px;
        padding-bottom: 0px;
      }

      & a {
        display: block !important;
        cursor: pointer !important;
        color: $cor_roxo_dark;
        font-size: 16px;
        font-family: 'VivoType';
        text-decoration: none;
        padding: 10px 25px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        -o-text-overflow: ellipsis;
        -ms-text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &:hover {
          background: $cor_cinza_dark;
          color: white;
        }

        & .thumb-categoria {
          display: none;
          cursor: pointer;
          background: $cor_rosa;
          font-size: 9px;
          color: white;
          padding: 2px 5px;
          margin-left: 10px;
          border-radius: 2px;
          font-family: 'OpenSans';
        }

        & img {
          display: none;
          width: 75px;
          height: 42px;
          border-radius: 5px;
          margin-right: 15px;
          object-fit: cover;
        }
      }
    }
  }

  & .seliga {
    position: relative;
    background: $cor_roxo;
    border-radius: 5px;
    margin: 80px 25px 30px 25px;
    padding: 25px;

    & img {
      position: absolute;
      top: -60px;
      left: 0px;
    }

    & h2 {
      font-family: 'VivoType';
      color: #660099;
      top: -60px;
      left: 80px;
      position: absolute;
    }

    & a {
      color: white;
      font-weight: bold;
      text-decoration: none;
      line-height: 30px;
      font-family: "VivoTypeBold";
      font-size: 1.12rem;
    }
  }

  & .vivoempauta {
    margin-top: 30px;

    & img {
      position: absolute;
      top: -18px;
      left: -16px;
      z-index: 99;
      height: 100px;
    }

    & h2 {
      font-family: VivoType;
      color: #660099;
      top: -10px;
      left: 100px;
      position: absolute;
    }
  }
}

@media all and (min-width: 300px) and (max-width: 679px) {
  aside {
    border-top: 3px solid $cor_roxo;
    margin-top: 30px;
    padding-top: 30px;
    border-radius: 0px;
    max-width: 100vw;
    min-width: 100vw;

    & /deep/ * {
      max-width: 100% !important;
    }

    & /deep/ iframe {
      max-width: 100% !important;
    }

    & /deep/ h2 {
      font-size: calc((((100vw + 100vh) * 2) / 170) + 10px) !important;
    }

    & /deep/ a {
      font-size: calc((((100vw + 100vh) * 2) / 220) + 6px) !important;
    }
  }
}

@media all and (min-width: 500px) and (max-width: 679px) {
  aside {
    & /deep/ .video {
      height: 300px;
    }

    & /deep/ .componente-lateral-holder {
      height: 300px;
    }

    & /deep/ iframe {
      height: 300px;
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  aside {
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-width: 600px;
    margin-top: 50px;
    padding-top: 30px;
    border-top: 3px solid $cor_roxo;

    & .topico {
      max-width: 260px;
      margin-right: 0px;
      margin-bottom: 30px;

      & /deep/ .componente-lateral-holder {
        max-width: 260px;
        height: auto;

        & /deep/ img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
        }

        & /deep/ iframe {
          width: 260px;
          height: 165px;
        }
      }

      & /deep/ h2 {
        padding: 0px
      }

      & ul {
        margin-bottom: 0px;

        & li {
          padding: 0px;

          & a {
            font-size: 12px;
            padding: 5px 0px;
            display: block;
          }
        }
      }
    }

    & .seliga {
      margin-top: 40px;
      width: calc(280px - 50px);

      & a {
        background: $cor_rosa;
        color: white;
        padding: 3px 10px;
        border-radius: 5px;
      }
    }

    & :nth-child(1).topico {
      order: 1
    }
    & :nth-child(3).topico {
      order: 2
    }
    & :nth-child(2).topico {
      order: 3
    }
  }

  aside .topico:nth-child(even) {
    margin-right: 0px !important;
  }
}
</style>
